import React from 'react';
import { Route, Switch } from 'react-router-dom';

import NavBar from '../components/NavBar';
import TokenList from '../components/TokenList';
import RegisterToken from '../components/RegisterToken';
import TokenDetails from '../components/TokenDetails';


function Index(props) {
  return (
    <>
    <NavBar history={props.history} />
      <Switch>
        <Route path="/" exact component={ TokenList } />
        <Route path="/register-nft" exact component={ RegisterToken } />
        <Route path="/nft/:protocol/:id" exact component={ TokenDetails } />
      </Switch>
    </>
  );
}

export default Index;
